import React, { ChangeEventHandler, FocusEventHandler, useContext, useEffect, useState } from "react";
import * as Yup from "yup";

interface AddTextFieldProps {
  id?: string;
  name?: string;
  title?: string;
  note?: string;
  footNote?: string;
  placeholder: string;
  index?: number;
  charAllowed: number;
  isCloseBtn?: boolean;
  value?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement> | undefined;
  onBlur?: FocusEventHandler<HTMLInputElement> | undefined;
  onClose?: (index: number) => void;
  notesclass?: string;
  showRemainingChar?: boolean;
  showError?: boolean;
  disabled?: boolean;
  error?: string;
}

export const AddTextField = ({
  id,
  name,
  title,
  note,
  footNote,
  placeholder,
  charAllowed,
  onClose,
  index,
  value = "",
  onChange,
  onFocus,
  onBlur,
  notesclass = "notes-class-content",
  isCloseBtn = false,
  showRemainingChar = true,
  showError = true,
  disabled = false,
  error,
}: AddTextFieldProps) => {
  const removeItem = () => {
    if (onClose && index !== undefined) {
      onClose(index);
    }
  };

  return (
    <>
      <div className="relative w-full min-w-[200px]">
        {title && (
          <div className="flex items-center">
            <span>{index && <span className="content_count">{index}</span>}</span>
            {title && <span className="content_title">{title}</span>}
          </div>
        )}
        {note && <div className={notesclass}>{note}</div>}
        <div className={`flex input-class ${title ? "mt-[15px]" : "mt-[0px]"}`}>
          <input
            type="text"
            name={name}
            id={name}
            className={`input-text ${disabled ? "text-skgray" : "text-black"}`}
            placeholder={placeholder}
            required
            maxLength={charAllowed}
            value={value}
            onChange={onChange}
            disabled={disabled}
            onFocus={onFocus}
            onBlur={onBlur}
          />
          {isCloseBtn && !disabled && (
            <div className="content-center w-4 h-4 align-middle shadow-md top-1 rounded-3xl bg-slate-600 max-w-[486px] mr-[5px] mt-[5px]">
              <button
                id="removeItem"
                className="top-0 left-0 right-0 content-center w-4 h-4 text-white "
                onClick={e => {
                  e.stopPropagation();
                  removeItem();
                }}
              >
                ×
              </button>
            </div>
          )}
        </div>

        {error && <span className="remaining-characters !text-skred">{error}</span>}

        {!error &&
          (footNote ? (
            <div className="remaining-characters">{footNote}</div>
          ) : charAllowed && showRemainingChar === true ? (
            !error && <div className="remaining-characters">{charAllowed - (value.length ?? 0)} characters remaining.</div>
          ) : (
            showRemainingChar && showError && <span className="remaining-characters">{"\u00A0"}</span>
          ))}

        {/* {!error && (
          <div className="remaining-characters">
            {charAllowed - (value.length ?? 0)} characters remaining.
          </div>
        )} */}
      </div>
    </>
  );
};
